import { useState, useEffect, useContext } from "react";
import axios from "axios";
import { ChevronLeft, ChevronRight } from "lucide-react";
import "../../../assets/css/customer/review/Review.css";
import AppContext from "../../../context/AppContext";

const Reviews = () => {
  const [activeReview, setActiveReview] = useState(1);
  const [reviews, setReviews] = useState([]);
  const [loading, setLoading] = useState(true);
  const { baseUrl } = useContext(AppContext);

  const fetchReviews = () => {
    console.log("Fetch Reviews Called");

    axios.get(`${baseUrl}/customer/order/homeReviews`)
      .then((response) => {
        if (response.data.success) {
          setReviews(response.data.reviews);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    fetchReviews();
  }, []);


  const nextReview = () =>
    setActiveReview((prev) => (prev === reviews.length - 1 ? 0 : prev + 1));

  const prevReview = () =>
    setActiveReview((prev) => (prev === 0 ? reviews.length - 1 : prev - 1));

  return (
    <section className="reviews-section">
      <div className="reviews-container">
        <div className="reviews-header">
          <span className="reviews-badge">Testimonials</span>
          <h2 className="reviews-title">What Our Customers Say</h2>
          <p className="reviews-subtitle">
            Discover why thousands of customers trust AD Furniture House for
            their home furnishing needs
          </p>
        </div>

        <div className="reviews-content">
          {/* Prev Button */}
          <button className="review-nav-btn prev" onClick={prevReview}>
            <ChevronLeft size={24} />
          </button>

          <div className="reviews-carousel">
            {reviews.map((review, index) => (
              <div
                key={review.id}
                className={`review-card ${index === activeReview ? "active" : ""} ${index === activeReview - 1 ||
                  (activeReview === 0 && index === reviews.length - 1)
                  ? "prev"
                  : ""
                  } ${index === activeReview + 1 ||
                    (activeReview === reviews.length - 1 && index === 0)
                    ? "next"
                    : ""
                  }`}
              >
                <div className="review-quote-icon">"</div>
                <div className="review-rating">
                  {[...Array(Number(review.rating))].map((_, i) => (
                    <span key={i} className="star">
                      ★
                    </span>
                  ))}
                </div>
                <p className="review-text">{review.review}</p>
                <div className="review-author">
                  <div className="author-image initials-avatar">
                    {review.customer_name
                      .split(" ")
                      .map((word) => word[0])
                      .join("")
                      .toUpperCase()}
                  </div>
                  <div className="author-info">
                    <h4 className="author-name">{review.customer_name}</h4>
                    <p className="author-role">Verified Customer</p>
                    <p className="review-date">{review.date}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Next Button */}
          <button className="review-nav-btn next" onClick={nextReview}>
            <ChevronRight size={24} />
          </button>
        </div>

        <div className="reviews-dots">
          {reviews.map((_, index) => (
            <button
              key={index}
              className={`dot ${index === activeReview ? "active" : ""}`}
              onClick={() => setActiveReview(index)}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Reviews;
